import { render } from "./Churches.vue?vue&type=template&id=d9567798&scoped=true"
import script from "./Churches.vue?vue&type=script&lang=js"
export * from "./Churches.vue?vue&type=script&lang=js"

import "./Churches.vue?vue&type=style&index=0&id=d9567798&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d9567798"]])

export default __exports__